/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_route_zoi_hotel__title = /** @type {(inputs: {}) => string} */ () => {
	return `Unterkünfte bei der Ankunft`
};

const en_route_zoi_hotel__title = /** @type {(inputs: {}) => string} */ () => {
	return `Accommodation on arrival`
};

const es_route_zoi_hotel__title = /** @type {(inputs: {}) => string} */ () => {
	return `Alojamiento a la llegada`
};

const fr_route_zoi_hotel__title = /** @type {(inputs: {}) => string} */ () => {
	return `Hébergements à l'arrivée`
};

const it_route_zoi_hotel__title = /** @type {(inputs: {}) => string} */ () => {
	return `Alloggio all'arrivo`
};

const nl_route_zoi_hotel__title = /** @type {(inputs: {}) => string} */ () => {
	return `Accommodatie bij aankomst`
};

const pt_route_zoi_hotel__title = /** @type {(inputs: {}) => string} */ () => {
	return `Alojamento à chegada`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const route_zoi_hotel__title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.route_zoi_hotel__title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("route_zoi_hotel__title", locale)
	if (locale === "de") return de_route_zoi_hotel__title(inputs)
	if (locale === "en") return en_route_zoi_hotel__title(inputs)
	if (locale === "es") return es_route_zoi_hotel__title(inputs)
	if (locale === "fr") return fr_route_zoi_hotel__title(inputs)
	if (locale === "it") return it_route_zoi_hotel__title(inputs)
	if (locale === "nl") return nl_route_zoi_hotel__title(inputs)
	return pt_route_zoi_hotel__title(inputs)
};